import { Inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { switchMap, withLatestFrom } from 'rxjs/operators';
import { MESSAGE_TYPE } from '../models/Message.model';
import {
  IMessagesService,
  MESSAGES_SERVICE,
} from '../services/IMessages.service';
import * as fromActions from './messages.actions';
import { MessagesStore } from './messages.store';

@Injectable()
export class MessagesEffects {
  filter$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.MessagesActionTypes.filterMessagesByReadStatusBegin),
      withLatestFrom(
        this.store.filteredItems$,
        this.store.gbmConversationsStore.conversationsData$,
        this.store.leadsStore.data$,
        this.store.reviewsStore.data$
      ),
      switchMap(
        ([action, filteredMessages, gbmData, leadsData, reviewsData]) => {

          const messageType: MESSAGE_TYPE = (action as any).messageType;

          /* let messageList = filteredMessages.filter((item) =>
          store.messages.filteredSources.includes(item.source)
        );

        messageList =
          messageType === 'ALL'
            ? messageList
            : messageList.filter((item) => {
                if (
                  messageType === 'READ' &&
                  (item as any).readStatus === undefined
                ) {
                  return true;
                }

                return (
                  (item as any).readStatus ===
                  (messageType === 'READ' ? true : false)
                );
              }); */

          return of(
            fromActions.filterMessagesByReadStatusSuccessAction({ payload: [] })
          );
        }
      )
    )
  );

  /* sortAndFilter$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.MessagesActionTypes.filterMessagesBySourceBegin),
      withLatestFrom(this.store$),
      switchMap(([action, store]) => {
        const sources: MessageSource[] = (action as any).sources;
        const sorting = (action as any).sorting as 'ASC' | 'DESC';

        const sortedMessages = store.messages.pageData.messages
          .map((m) => m) // <-- because pageData.messages is READ ONLY!!
          .sort((a, b) => {
            if (sorting === 'ASC') {
              return b.createTime.localeCompare(a.createTime);
            } else {
              return a.createTime.localeCompare(b.createTime);
            }
          });

        const filteredMessages = sortedMessages.filter((item) =>
          sources.includes(item.source)
        );

        return of(
          fromActions.filterMessagesBySourceSuccessAction({
            sorting,
            sources,
            sortedMessages, // <-- all messages but sorted, if you need them somewhere
            filteredMessages,
          })
        );
      })
    )
  ); */

  constructor(
    private actions$: Actions,
    private store: MessagesStore,
    @Inject(MESSAGES_SERVICE) private service: IMessagesService
  ) {}
}
